import { render, staticRenderFns } from "./ResetPassSuccess.vue?vue&type=template&id=28560f93"
import script from "./ResetPassSuccess.vue?vue&type=script&lang=js"
export * from "./ResetPassSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports